import type { CSSProperties, FC } from 'react';

import classNames from 'classnames';

import { ui } from '../../utils/helpers';

import styles from './loading_bar.module.css';

type Props = {
  className?: string;
  style?: CSSProperties;
};

const LoadingBar: FC<Props> = (props) => (
  <div
    style={props.style}
    className={classNames(styles.bar, props.className)}
    {...ui('loading-bar')}
    role="progressbar"
    tabIndex={-1}
  >
    <div />
  </div>
);

export default LoadingBar;
